import { useMutation, useQueryClient } from 'react-query';
import * as userApi from 'resources/user/user.api';

export default function useUpdateRealtorsTeam() {
  const queryClient = useQueryClient();

  return useMutation(
    (requestData) => userApi.updateRealtorsTeam(requestData),
    {
      onSuccess: async (data, variables) => {
        queryClient.invalidateQueries(['users.getRealtors']);
        queryClient.invalidateQueries(['users.getRealtorsByTeam', variables.teamId]);
        queryClient.invalidateQueries(['users.getClientsByTeam', variables.teamId]);
        queryClient.invalidateQueries(['deal.getByTeamId', variables.teamId]);

        await Promise.all(data.map(async (realtorId) => queryClient.invalidateQueries(['users.userById', realtorId])));
      },
    },
  );
}
